import { render, staticRenderFns } from "./ServicesInvoice.vue?vue&type=template&id=393b5cec&scoped=true"
import script from "./ServicesInvoice.vue?vue&type=script&lang=js"
export * from "./ServicesInvoice.vue?vue&type=script&lang=js"
import style0 from "./ServicesInvoice.vue?vue&type=style&index=0&id=393b5cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b5cec",
  null
  
)

export default component.exports